<script>
  import options from './MaterialCard.options'
  export default options
</script>

<template>
  <a class="kb-material-card" :href="data.url">

    <figure class="kb-material-card__image kb-image-module kb-image-module--A4">
      <div class="kb-image-module__image-container">
        <picture class="kb-image-module__image">
          <source :srcset="data.imageUrl" media="(min-width:1024px)">
          <source :srcset="data.imageUrl" media="(min-width: 768px)">
          <source :srcset="data.imageUrl" media="(min-width: 376px)">
          <source :srcset="data.imageUrl" media="(max-width: 376px)">
          <img :src="data.imageUrl" alt="">
        </picture>
      </div>
      <template v-if="data.saleLabelText">
        <div class="kb-product-card__sale-label" :class="data.labelColorTheme">
          {{ data.saleLabelText }}
        </div>
      </template>
    </figure>

    <div class="kb-material-card__content-wrapper">

      <h3 class="kb-material-card__title">
        {{ data.title }}
      </h3>
  
      <div class="kb-material-card__price-wrapper">
        <p class="kb-material-card__price">
          {{ data.displayPrice }}
        </p>

        <template v-if="data.displayBeforePrice">
          <p class="kb-product-card__price--before">
            Førpris
            <span class="kb-product-card__price--before-line-through">{{ data.displayBeforePrice }}</span>
          </p>
        </template>
  
      </div>

    </div>

  </a>
</template>
